const MAGENTO_LIKE_DATE = /^(\d{4}-\d{2}-\d{2})([ T])(\d{2}:\d{2}(:\d{2})?)(?:\.\d+)?$/;
const OFFSET_SUFFIX = /([zZ]|[+-]\d{2}:?\d{2})$/;

const toDate = (input) => {
  if (input === null || input === undefined) return null;
  const raw = String(input).trim();
  if (!raw) return null;

  // Handle unix timestamps (seconds or milliseconds)
  if (/^\d+$/.test(raw)) {
    const num = Number(raw);
    if (Number.isFinite(num)) {
      return raw.length === 10 ? new Date(num * 1000) : new Date(num);
    }
  }

  let candidate = raw;
  if (MAGENTO_LIKE_DATE.test(raw) && !OFFSET_SUFFIX.test(raw)) {
    // Magento returns UTC without offset; append Z to force UTC
    candidate = raw.replace(' ', 'T').concat('Z');
  }

  // Replace space with T to improve Date parsing across browsers
  if (!candidate.includes('T') && MAGENTO_LIKE_DATE.test(candidate)) {
    candidate = candidate.replace(' ', 'T');
  }

  const parsed = new Date(candidate);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  // Final fallback: try raw string without mutations
  const fallback = new Date(raw);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

const getStoredTimeZone = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const direct = window.localStorage.getItem('storeTimezone') || window.localStorage.getItem('magentoTimezone');
    if (direct && direct.trim()) return direct.trim();
  } catch (err) {
    // Ignore storage access issues silently
  }
  return null;
};

const resolveTimeZone = (override) => {
  const candidates = [override, getStoredTimeZone(), 'Europe/Dublin', 'UTC'];
  for (const tz of candidates) {
    if (!tz) continue;
    try {
      // Accessing resolvedOptions ensures the timeZone is valid
      Intl.DateTimeFormat(undefined, { timeZone: tz }).resolvedOptions();
      return tz;
    } catch (_err) {
      // try next candidate
    }
  }
  return undefined;
};

export const formatMagentoDateTime = (input, options = {}) => {
  const date = toDate(input);
  if (!date) return '-';

  const { timeZone, locale = 'en-GB', formatOptions = {} } = options;
  const resolvedTimeZone = resolveTimeZone(timeZone);

  const baseOptions = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...formatOptions,
  };

  try {
    return new Intl.DateTimeFormat(locale, {
      ...baseOptions,
      timeZone: resolvedTimeZone,
    }).format(date);
  } catch (_err) {
    return new Intl.DateTimeFormat(locale, baseOptions).format(date);
  }
};

export const parseMagentoDate = (input) => toDate(input);

